import SearchIcon from '../../../../../ui/svg/common/search';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';

export const FilterArtists = () => {

    const dispatch = useAppDispatch();
    const filterPlaceholderText = useAppSelector(store => store.filterPlaceholderText);
    const filterTerm = useAppSelector(store => store.filterTerm);

    /**
     * apply text filter
     */
    const applyFilter = (updatedFilterTerm: string) => {
        dispatch(
            rootActions.refresh({
                filterTerm: updatedFilterTerm,
                currentPage: 0,
            })
        );
    };

    return (
        <div className="flex items-center">
            <input
                className="text-sm font-normal text-gray-500 px-4 py-1 outline-none"
                aria-label={ filterPlaceholderText }
                value={ filterTerm }
                autoComplete="off"
                type="text"
                placeholder={ filterPlaceholderText }
                onInput={evt => {
                    const $el = evt.target as HTMLFormElement;
                    applyFilter($el.value);
                }}
                onClick={evt => {
                    sendGAEvent('JPList', 'Top Search');
                }}
                style={{
                    width: '170px'
                }}
            />
            <SearchIcon width="13px" color="#252525" title="Filter" />
        </div>
    )
};